// extracted by mini-css-extract-plugin
module.exports = {"formSection":"XDHlRolY_ZvA4RhcNZtLr","title":"_3RDpFXL4Glqg1pd6cJe69_"};